import Papa from "papaparse";
import { dibels_columns } from "../../../../utils/files";

/**
 * Handler for mClass file format
 */
export class MClassHandler {
  
  /**
   * Process mClass CSV data with double header handling
   */
  static processMClassData(
    csvDataArray: string[],
    isDoubleHeaderLinkIt: boolean,
    setDoubleHeaderFlag: (flag: boolean) => void
  ): string[] {
    const csvRowStrArray: string[] = [];
    let isStringFound: boolean = false;
    let isIsteepFileDetected = false;

    const studentIDColumn: string[] = [
      'ID',
      'Student ID',
      'Student ID#',
      'student_id',
      'StudentId',
      'Student_ID',
      'first_name',
      'last_name',
      'First',
      'Last'
    ];

    for (let i = 0; i < csvDataArray.length; i++) {
      let csvRowStr = csvDataArray[i];

      // Handle DIBELS title columns
      if (csvRowStr.includes('"ID"')) {
        let csvRow = csvRowStr.split(',');
        const title = csvRow.find((row) => row.match('DIBELS'));
        csvRow = csvRow.map((rowData: string) => {
          if (rowData === "" && title !== undefined) {
            rowData = title;
          }
          return rowData;
        });
        csvRowStr = csvRow.join(',');
      }

      // Check for iSteep file
      if (csvRowStr.toLowerCase().includes('Test Date'.toLowerCase())) {
        isIsteepFileDetected = true;
      }

      // Skip blank rows until header found
      if (!studentIDColumn.some((sid) => csvRowStr.includes(sid)) && !isStringFound) {
        continue;
      }

      // Handle double header for mClass files
      if (
        csvDataArray[0] !== '' &&
        (csvDataArray[0].includes('StudentSummary') || csvDataArray[0].includes('Student Summary')) &&
        !csvDataArray[0].includes('District_Name')
      ) {
        const doubleHeaderColumnHave = [
          dibels_columns.LNF,
          dibels_columns.PSF,
          dibels_columns["NWF-CLS"],
          dibels_columns["NWF-WRC"],
          dibels_columns.WRF,
          dibels_columns["ORF-WordsCorrect"],
          dibels_columns["ORF-Accuracy"],
          dibels_columns["Maze-Adjusted"],
          dibels_columns.Composite
        ];

        if (
          csvDataArray[i + 1] &&
          !isIsteepFileDetected &&
          doubleHeaderColumnHave.filter((double) => {
            const csvRow = csvDataArray[i + 1].toLowerCase().split(',');
            return double.some((col) => (csvRow || []).includes(col.toLowerCase()));
          }).length > 0 &&
          !isDoubleHeaderLinkIt
        ) {
          // Merge double headers
          const firstHeader = csvDataArray[i]
            .split(',')
            .filter((data) => data)
            .map((str) => {
              const fourDigitRegex = /\b\d{4}\b/g;
              const twoDigitRegex = /\b\d{2}\b/g;
              const oneDigitRegex = /\b\d{1}\b/g;
              if (
                fourDigitRegex.test(str) === true ||
                twoDigitRegex.test(str) === true ||
                oneDigitRegex.test(str) === true
              ) {
                return "";
              } else {
                return str;
              }
            })
            .filter((data) => data)
            .join(',');

          csvDataArray[i + 1] = csvDataArray[i + 1]
            .split(',')
            .filter((data) => data)
            .join(',');

          csvRowStr = firstHeader.concat(',').concat(csvDataArray[i + 1]);
          csvDataArray.splice(i + 1, 1);
          setDoubleHeaderFlag(true);
        }
      }

      isStringFound = true;
      const csvRowSubStringArray = csvRowStr.split(',');
      const isArrayBlank = csvRowSubStringArray.every((data) => data.trim() === '');

      if (!isArrayBlank) {
        csvRowStrArray.push(csvRowStr);
      }
    }

    return csvRowStrArray;
  }

  /**
   * Parse mClass data using Papa Parse
   */
  static parseMClassData(
    csvData: string,
    updateDataCallback: (result: any, file: File) => void
  ): void {
    Papa.parse(csvData, {
      complete: updateDataCallback,
      header: true,
      dynamicTyping: true,
      trimHeaders: true,
      skipEmptyLines: true,
      transform(value: string, field: string | number): any {
        return value.trim();
      },
      transformHeader(header: string): any {
        return header.trim();
      },
    });
  }
}
